import { Component, ElementRef, OnInit } from '@angular/core';
import { RepositoryService } from './../../shared/services/repository.service';
import { Risk } from './../../_interfaces/risk.model';
import { ImportResult } from './../../_interfaces/ImportResult.model';
import { Router } from '@angular/router';
import { RiskUser } from './../../_interfaces/RiskUser.model';

import { FormBuilder, FormGroup } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject, combineLatest, Subject } from 'rxjs';
import { distinctUntilChanged, map, switchMap, tap } from 'rxjs/operators';
import { RiskService } from '../../shared/services/risk.service';
import { RiskType } from '../../_interfaces/RiskType.model';
import { RiskCategory } from 'src/app/_interfaces/RiskConfig.model';


@Component({
  selector: 'app-my-risk-list',
  templateUrl: './my-risk-list.component.html',
  styleUrls: ['./my-risk-list.component.css']
})

export class MyRiskListComponent implements OnInit {
  //@ViewChild('fileInput')

  fileInput: ElementRef;
  public fileData: File = null;
  public finRiskType: number;
  public stratRiskType: number;
  public opRiskType: number;
  public user$: Subject<RiskUser> = this.repository.user$;
  public showImportForm: boolean;
  public showResult: boolean;
  public importResultMessage: string;

  public importExcelForm: FormGroup;

  public risks$: Observable<Risk[]>;

  private selectedCategory: BehaviorSubject<RiskType> = new BehaviorSubject(RiskCategory.MyRisks);
  private selectedHeadlineRisk: BehaviorSubject<number> = new BehaviorSubject(null);


  public selectedCategory$ = this.selectedCategory.asObservable()
    .pipe(
      //clear headline risk per category change
      tap(() => this.selectedHeadlineRisk.next(null))
    );
  public selectedHeadlineRisk$ = this.selectedHeadlineRisk.asObservable();

  //get headline risks, if any, for selected risk type
  public headlineRisks$ = this.selectedCategory.pipe(
    switchMap((selectedCategory) => 
      this.riskService.filterHeadlineRisks(selectedCategory.id)
    )
  );

  constructor(private repository: RepositoryService, private riskService: RiskService,
    private router: Router, private formBuilder: FormBuilder, private http: HttpClient) {
    this.finRiskType = 0;
  }

  ngOnInit() {
    //get new risks when category or headline options have changed
    this.risks$ = combineLatest(([this.selectedCategory$, this.selectedHeadlineRisk$]))
      .pipe(
        //dont update risks when riskType hasn't changed and headline risk is null
        distinctUntilChanged((previous, current) => {
          return (previous[0] === current[0] && current[1] === null);
        }),
        switchMap(([riskType, headlineRisk]) => {
          return headlineRisk ?
            this.riskService.getRisksForHeadlineRisks(riskType, headlineRisk) :
            this.riskService.getRisksForCategory(riskType);
        })
      );
  }

  public getStrategicRisks() {
    this.selectedCategory.next(RiskCategory.Strategic);
  }

  public getOperationalRisks() {
    this.selectedCategory.next(RiskCategory.Operational);
  }

  public getFinancialRisks() {
    this.selectedCategory.next(RiskCategory.Financial);
  }

  public getMyRisks() {
    this.selectedCategory.next(RiskCategory.MyRisks);
  }

  public getMyManagerRisks() {
    this.selectedCategory.next(RiskCategory.MyManagerRisks);
  }

  public getAllRisks() {
    this.selectedCategory.next(RiskCategory.AllRisks);
  }

  public getEmergingRisks() {
    this.selectedCategory.next(RiskCategory.Emerging);
  }

  public getRiskDetails(riskId: number) {
    let riskDetailUrl: string = `/myrisks/details/${riskId}`;
    this.router.navigate([riskDetailUrl]);
  }
  public editRiskRecord(riskId: number) {
    let riskDetailUrl: string = `/myrisks/edit-risk/${riskId}`; // 
    this.router.navigate([riskDetailUrl]);
  }

  public getMessageFromChild(message: string) {
    if (message === 'refresh') {
      // ToDo - add code to save which mode the page is in and use it here when refreshing the page.
      this.getMyRisks();
    }
  }

  public addNewRisk() {
    let addRiskUrl: string = `/myrisks/add-risk`;
    this.router.navigate([addRiskUrl]);
  }

  public importRiskData() {
    // ToDo - add code to upload the imported data to the Web-api backend
    if (!this.showImportForm) {
      this.showImportForm = true;
    }
    else {
      this.showImportForm = false;
    }


    // end
  }

  //get f() { return this.importExcelForm.controls; }
  uploadFile() {
    //let formData = new FormData();
    //formData.append('upload', this.fileInput.nativeElement.files[0]);
    // ToDo - create and call repository method to post the file
    let formData = new FormData();
    formData.append('file', this.fileData);


    // ToDo - update this line with the new api endpoint
    let apiAddress: string = `Risks/ImportFinancialRiskValues`;

    // ToDo - un-comment this method and test with the new api endpoint
    this.repository.uploadFile(apiAddress, formData)
      .subscribe(res => {
        // Update the dialog contents
        const result = res as ImportResult;
        //if (result.includes('success')) {
        //  // To Do - display an import success message
        //}

        this.importResultMessage = result.message;
        this.showResult = true;

        // this.showImportForm = false;
      });;

    //this.showImportForm = false;
  }
  hideResult() {
    this.showResult = true;
    this.showImportForm = false;
  }


  onFileSelect(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (!file.name.includes(".xlsx")) {
        alert('Please select a xlsx file with the Financial Risk Import Details! :-)\n\n');
        return;
      }

      this.fileData = file;

    }

  }
}
